module.exports = __webpack_public_path__ + "static/Unilever-DSEP-ClassroomActivity-Virtual-1.2-BodyTalk_FR-f5ad7d31e07d26554ab9f78f64975b9f.pdf";